import React from 'react'
import { pure } from 'react-recompose'
import Svg from '../shared/Svg'

const House = props => (
  <Svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-357.000000, -328.000000)" fill="#4A4A4A" fillRule="nonzero">
        <g transform="translate(308.000000, 94.000000)">
          <g transform="translate(49.000000, 231.000000)">
            <path
              d="M15.5448335,9.62257917 C15.6174702,9.66350002 15.6780968,9.72323125 15.720105,9.79516457 L17.8601794,11.9024409 C18.0445893,12.0840245 18.0468804,12.3807209 17.8652967,12.5651307 C17.6837131,12.7495405 17.3870167,12.7518316 17.2026069,12.570248 L15.7837668,11.1731526 L15.7837668,17.6280749 C15.7837668,19.3164994 14.403459,20.6988252 12.7130165,20.6988252 L5.39173015,20.6988252 C3.70330559,20.6988252 2.32097978,19.3185174 2.32097978,17.6280749 L2.32097978,11.0337542 L0.801360613,12.5662936 C0.619134727,12.7500688 0.322432206,12.7513248 0.138656983,12.5690989 C-0.0451182395,12.386873 -0.0463742255,12.0901705 0.13585166,11.9063953 L8.56525436,3.40532336 C8.74703088,3.22200133 9.04284001,3.22023312 9.2267951,3.40136896 L15.5448332,9.62257891 Z M3.25819264,10.0885729 L3.25819264,17.6280749 C3.25819264,18.8006023 4.2206077,19.7616124 5.39173015,19.7616124 L12.7130165,19.7616124 C13.8855439,19.7616124 14.846554,18.7991973 14.846554,17.6280749 L14.846554,10.2503032 L8.90196326,4.39681728 L3.25819264,10.0885729 Z M9.03583426,18.3998972 C6.56958262,18.3998972 4.57029064,16.4006053 4.57029064,13.9343536 C4.57029064,11.468102 6.56958262,9.46881 9.03583426,9.46881 C11.5020859,9.46881 13.5013779,11.468102 13.5013779,13.9343536 C13.5013779,16.4006053 11.5020859,18.3998972 9.03583426,18.3998972 Z M9.03583426,16.7459922 C10.5886594,16.7459922 11.8474728,15.4871787 11.8474728,13.9343536 C11.8474728,12.3815285 10.5886594,11.122715 9.03583426,11.122715 C7.48300915,11.122715 6.22419569,12.3815285 6.22419569,13.9343536 C6.22419569,15.4871787 7.48300915,16.7459922 9.03583426,16.7459922 Z"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg>
)

export default pure(House)
